import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { TeeTimeBookingOptions } from 'src/data/mygolf.data';

@Component({
  selector: 'app-tee-slot-settings',
  templateUrl: './tee-slot-settings.component.html',
  styleUrls: ['./tee-slot-settings.component.scss'],
})
export class TeeSlotSettingsComponent implements OnInit {

  @Input() bookingOptions: TeeTimeBookingOptions;
  @Input() minPlayers: any;
  @Input() maxPlayers: any;
  @Input() buggyMandatory: any;
  @Input() buggyMax: any;
  @Input() caddyMandatory: any;
  @Input() caddyMax: any;
  @Input() slotHasJumbo: any;
  @Input() buggyMaxJumbo: any;
  @Input() caddyMaxJumbo: any;
  @Input() heading: string;
  @Input() message: any;
  @Input() isErrorModal: boolean = false;

  constructor(
    private modalCtl: ModalController
  ) {

    console.log(this.bookingOptions,'bookingOptions 11')

  }

  ngOnInit() {
    console.log(this.bookingOptions,'bookingOptions 22')
  }

  dismiss(){
    this.modalCtl.dismiss();
  }
}
